import React, { useState } from 'react';
import { metricHeading, metricKey } from './format';

const OPS = ['>=', '<=', '>', '<'];

// AND-ed rules on a metric's value or its cohort percentile. Nulls never pass.
export default function ThresholdEditor({ catalogue, metrics, thresholds, setThresholds }) {
  const [metric, setMetric] = useState('');
  const [field, setField] = useState('percentile');
  const [op, setOp] = useState('>=');
  const [value, setValue] = useState('50');
  const keys = metrics.map((m) => ({ key: metricKey(m), label: metricHeading(m, catalogue), unit: catalogue?.statistics?.find((s) => s.key === m.statistic)?.unit }));
  const chosen = keys.find((k) => k.key === metric) || keys[0];
  const add = () => {
    if (!chosen || value === '' || Number.isNaN(Number(value))) return;
    setThresholds([...thresholds, { metric: chosen.key, field, op, value: Number(value) }]);
  };
  const remove = (i) => setThresholds(thresholds.filter((_, k) => k !== i));
  return (
    <div className="qs-thresholds">
      <div className="qs-chips">
        {thresholds.map((t, i) => {
          const k = keys.find((x) => x.key === t.metric);
          const shown = t.field === 'percentile' ? `pct ${t.op} ${t.value}` : `${t.op} ${k?.unit === 'pct' ? `${t.value}%` : t.value}`;
          return (
            <span key={`${t.metric}-${i}`} className="qs-chip qs-chip-rule">
              {k?.label || t.metric} {shown}
              <button type="button" className="qs-chip-x" onClick={() => remove(i)} aria-label="remove">×</button>
            </span>
          );
        })}
        {thresholds.length === 0 && <span className="qs-muted">No threshold rules. Rules are AND-ed; a fund with no value never passes.</span>}
      </div>
      {keys.length > 0 && (
        <div className="qs-metric-form">
          <select value={chosen?.key || ''} onChange={(e) => setMetric(e.target.value)}>
            {keys.map((k) => <option key={k.key} value={k.key}>{k.label}</option>)}
          </select>
          <select value={field} onChange={(e) => setField(e.target.value)}>
            <option value="percentile">percentile</option>
            <option value="value">value{chosen?.unit === 'pct' ? ' (%)' : ''}</option>
          </select>
          <select value={op} onChange={(e) => setOp(e.target.value)}>
            {OPS.map((o) => <option key={o} value={o}>{o}</option>)}
          </select>
          <input type="number" step="any" value={value} onChange={(e) => setValue(e.target.value)} style={{ width: 90 }} />
          <button type="button" className="qs-btn" onClick={add}>Add rule</button>
        </div>
      )}
    </div>
  );
}
